import { SuggestedAddressRules } from "./suggested-address-rules.abstract";

export class BaskRulesService extends SuggestedAddressRules {
  icon = "/assets/images/bask/bask-house-icon.svg";
}
